const main = "https://docs.release.com";

// Nested Slugs
const getStarted = "getting-started";
const setupExamples = "common-setup-examples";
const examples = "examples";
const integrations = "integrations";
const integrationsOverview = "integrations-overview";
const instantDatasetTasks = "instant-dataset-tasks";
const refDocumentation = "reference-documentation";
const refGuide = "reference-guide";
const refExamples = "reference-examples";
const acctSettings = "account-settings";
const sourceCtrl = "source-control-integrations";
const apiDoc = "api-documentation";
const advanced = "advanced";
const advancedSetup = "advanced-setup";
const applicationSettings = "application-settings";
const environmentSettings = "environment-settings";
const guidesExamples = "guides-and-examples";
const instantDatasets = "release-instant-datasets";
const releaseAi = "release-ai";

const docRoutes = {
  base: main,
  overview: `${main}/release-overview`,

  // Getting Started
  prepare: `${main}/${getStarted}/prepare-to-use-release`,
  createApp: `${main}/${getStarted}/create-an-application`,
  quickstart: `${main}/${getStarted}/quickstart`,

  // Advanced Setup
  manageDomains: `${main}/${getStarted}/${advancedSetup}/managing-your-domains`,
  createClusters: `${main}/${getStarted}/${advancedSetup}/create-a-cluster`,
  importClusters: `${main}/${integrations}/${integrationsOverview}/aws-integration/using-an-existing-eks-cluster`,

  // Common Setup Examples
  commonSetupExamples: `${main}/${getStarted}/${setupExamples}/`,
  multiPortTraffic: `${main}/${getStarted}/${setupExamples}/serve-traffic-on-multiple-ports`,
  changeHostnames: `${main}/${getStarted}/${setupExamples}/change-hostnames`,
  loadBalancer: `${main}/${getStarted}/${setupExamples}/load-balancer-with-hostname`,
  overRide: `${main}/${getStarted}/${setupExamples}/service-needs-more-memory`,
  microService: `${main}/${getStarted}/${setupExamples}/microservices-architecture`,

  // Examples
  static: `${main}/${examples}/simple-static-build-example-gatsby-starter-theme`,
  docker: `${main}/${examples}/example-voting-app`,
  hybrid: `${main}/${examples}/hybrid-docker-+-static-site-example`,

  // Integrations
  LaunchDarkly: `${main}/${integrations}/${integrationsOverview}/launchdarkly-integration`,
  awsIntegration: `${main}/${integrations}/${integrationsOverview}/aws-integration`,
  gcpIntegration: `${main}/${integrations}/${integrationsOverview}/gcp-integration`,

  // Reference Documentaion
  accountSettings: `${main}/${refDocumentation}/${acctSettings}`,
  acctInfo: `${main}/${refDocumentation}/${acctSettings}/account-info`,
  addUser: `${main}/${refDocumentation}/${acctSettings}/managing-users#inviting-users`,
  buildArgs: `${main}/${refDocumentation}/${acctSettings}/build-args`,
  addInt: `${main}/${refDocumentation}/${acctSettings}/add-integrations`,
  viewCluster: `${main}/${refDocumentation}/${acctSettings}/view-clusters`,
  addDatasets: `${main}/${refDocumentation}/${acctSettings}/add-datasets`,
  envHandles: `${main}/${refDocumentation}/${acctSettings}/environment-handles`,
  workflows: `${main}/${refDocumentation}/workflows-in-release`,

  // Reference Guide
  envVarMappings: `${main}/${refGuide}/${refExamples}/environment-variable-mappings`,

  version: `${main}/${refDocumentation}/release-environment-versioning`,

  datasets: `${main}/${refDocumentation}/instant-datasets`,
  datasetsAws: `${main}/${refDocumentation}/instant-datasets/aws`,
  datasetTasks: `${main}/${refDocumentation}/${instantDatasetTasks}`,
  tonicDatasetTask: `${main}/${refDocumentation}/${instantDatasetTasks}/tonic-cloud`,
  sourceCtrlInt: `${main}/${refDocumentation}/${sourceCtrl}`,
  github: `${main}/${refDocumentation}/${sourceCtrl}/github`,
  bitbucket: `${main}/${refDocumentation}/${sourceCtrl}/bitbucket`,
  staticDeploy: `${main}/${refDocumentation}/static-service-deployment`,
  releaseFile: `${main}/${refDocumentation}/release.yaml`,

  // Application Settings
  defaultEnvConfig: `${main}/${refDocumentation}/${applicationSettings}/application-template`,
  defaultEnvVars: `${main}/${refDocumentation}/${applicationSettings}/default-environment-variables`,
  fileMounts: `${main}/${refDocumentation}/${applicationSettings}/file-mounts`,
  primaryAppLink: `${main}/${refDocumentation}/${applicationSettings}/primary-app-link`,

  // Environment Settings
  envConfig: `${main}/${refDocumentation}/${environmentSettings}/environment-configuration`,
  envVars: `${main}/${refDocumentation}/${environmentSettings}/environment-specific-environment-variables`,
  managingSecrets: `${main}/${refDocumentation}/${environmentSettings}/environment-specific-environment-variables/managing-secrets`,

  // API Doc
  api: `${main}/${apiDoc}/release-api`,
  auth: `${main}/${apiDoc}/release-api/authentication`,
  createStaging: `${main}/${apiDoc}/release-api/create-a-staging-environment`,

  // Advanced
  multiEnvs: `${main}/${advanced}/designing-for-multiple-environments`,
  monitorCluster: `${main}/${advanced}/monitoring-your-release-cluster`,
  dns: `${main}/${advanced}/external-dns`,

  // Guides and Examples
  applicationPausingSchedules: `${main}/${guidesExamples}/advanced-guides/pausing-instant-datasets/application-pausing-schedules`,

  // Standalone Datasets
  datasetsQuickstart: `${main}/${instantDatasets}/quickstart`,
  datasetsSecurity: `${main}/${instantDatasets}/security`,

  // Release AI
  aiIntroduction: `${main}/${releaseAi}/introduction`,
  cliGettingStarted: `${main}/cli/getting-started`,

  // Node Groups
  createNodeGroup: `${main}/${guidesExamples}/advanced-guides/managing-your-node-groups#adding-a-node-group`,
};

export default docRoutes;
